import { useAppContext, Platform } from '@at/sauron-platform-core'

export const useCheckPlatform = () => {
    const { isDesktop } = useAppContext()
    const platform = isDesktop() ? Platform.desktop : Platform.mobile
    return {
        platform,
    }
}
